import React, { useState, useEffect, Suspense } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Pagination, PaginationItem, PaginationLink, Input } from 'reactstrap';

const SOHViewModel = ({ payload, isOpen, toggleModal }) => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);  // Track the current page
    const [itemsPerPage] = useState(10);  // Number of items to display per page
    const [searchTerm, setSearchTerm] = useState("");  // Search term state
    const [displayMessage, setDisplayMessage] = useState(""); // State to control the display of the message
    const [columns, setColumns] = useState([]); // State to control the columns of the table

    useEffect(() => {
        // Fetch data when modal opens and payload changes
        if (isOpen && payload) {
            setData([]); // Clear the data when modal opens
            fetchData();
        }else{
            setData([]); // Clear the data when modal closes
        }
        setCurrentPage(1);  // Reset to the first page when modal opens
    }, [isOpen, payload]); // Depend on isOpen and payload

    const fetchData = async () => {
        setLoading(true);

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        // Prepare the request payload
        const requestPayload = {
            txnType: payload.txnType,
            supplier: payload.supplier,
            customer: payload.customer,
            productCode: payload.productCode,
            stockCode: payload.stockCode,
            fromLocation: payload.fromLocation,
            toLocation: payload.toLocation,
            beforeDate: payload.beforeDate || "1900-01-01",
            afterDate: payload.afterDate || "1900-01-01",
            orderDays: payload.orderDays,
        };

        let requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(requestPayload), // Sending data as JSON
            redirect: "follow",
        };

        try {
            // Make the POST request to the API
            const response = await fetch(`${ApiURL}txn/getallSOH`, requestOptions);
            const result = await response.json();
            setData(result.data); // Assuming the response contains data
            setFilteredData(result.data); // Set filtered data as well
            setDisplayMessage(result.displayMessage);
            setColumns(result.columns); // Assuming the response contains columns
        } catch (error) {
            console.error('Error fetching stock data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Get data for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    // Handle page change
    const paginate = (pageNumber) => setCurrentPage(pageNumber);    // Handle search
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        // Filter the data based on search term (searching across all columns dynamically)
        const filtered = data.filter(item => {
            // If search term is empty, return all data
            if (!value) return true;
            
            // Check if any value in any column includes the search term
            return columns.some(column => {
                const cellValue = item[column];
                // Check if the cell value exists and is a string or can be converted to a string
                return cellValue !== undefined && 
                       cellValue !== null && 
                       String(cellValue).toLowerCase().includes(value.toLowerCase());
            });
        });

        setFilteredData(filtered);
        setCurrentPage(1);  // Reset to the first page when search is updated
    };

    return (
        <Modal isOpen={isOpen} toggle={toggleModal} size="lg" centered>
            <ModalHeader toggle={toggleModal}>{displayMessage}</ModalHeader>
            <ModalBody>
                {/* Search Input */}                <Input
                    type="text"
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Search across all columns"
                    style={{ marginBottom: "20px" }}
                />
                <Suspense fallback={<div>Loading...</div>}>
                    <div>
                        <Table bordered>
                            <thead>
                                <tr>{columns.map((column, index) => (
                                    <th key={index}>{column}</th>
                                ))}</tr>
                            </thead>
                            <tbody>
                                {currentItems.length === 0 ? (
                                    <tr>
                                        <td colSpan="4">No data available</td>
                                    </tr>
                                ) : (
                                    currentItems.map((item, index) => (
                                        <tr key={index}>
                                            {columns.map((column, colIndex) => (
                                                <td key={colIndex}>{item[column]}</td>
                                            ))}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>

                        {/* Pagination Controls */}
                        <div className="d-flex justify-content-end">
                            <Pagination size='sm'>
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink previous onClick={() => paginate(currentPage - 1)} />
                                </PaginationItem>
                                {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                                    <PaginationItem active={index + 1 === currentPage} key={index}>
                                        <PaginationLink onClick={() => paginate(index + 1)}>
                                            {index + 1}
                                        </PaginationLink>
                                    </PaginationItem>
                                ))}
                                <PaginationItem disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
                                    <PaginationLink next onClick={() => paginate(currentPage + 1)} />
                                </PaginationItem>
                            </Pagination>
                        </div>

                    </div>
                </Suspense>
                {/* Display loading spinner or table */}
                {/* {loading ? (
                    <p>Loading...</p>
                ) : ( */}

                {/* )} */}
            </ModalBody>
        </Modal >
    );
};

export default SOHViewModel;
